import { Injectable, Injector, OnDestroy } from '@angular/core';
import { Subscription } from '@app/shared/rx/rx-wrapper';
import { forEach } from 'lodash';
import { ServiceWithCustomHttp } from './service-with-custom-http.service';

@Injectable()
export class BaseInjectService
  extends ServiceWithCustomHttp
  implements OnDestroy
{
  public subscriptions: Subscription[] = [];

  public constructor(public injector: Injector) {
    super(injector);
  }

  public ngOnDestroy(): void {
    forEach(this.subscriptions, (subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }
}
